import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getJobPost } from 'selectors/jobPosts';
import { deleteJobPost, publishJobPost } from '../actions';

interface UseJobPostHandlers {
  deleteJobPostHandler: VoidFunction;
  publishJobPostHandler: VoidFunction;
  loading: boolean;
  jobPost: any;
  userInfo: any;
}

const useJobPost = (jobPostId: number): UseJobPostHandlers => {
  const dispatch = useDispatch();
  const deleteJobPostHandler = useCallback(() => dispatch(deleteJobPost(jobPostId)), [
    dispatch,
    jobPostId,
  ]);
  const publishJobPostHandler = useCallback(
    () => dispatch(publishJobPost({ jobPostId, status: 'active' })),
    [dispatch, jobPostId]
  );
  const { loading } = useSelector<any, any>(state => state);

  const jobPost = useSelector<any, any>((state: any) => getJobPost(state, jobPostId));
  const userInfo = useSelector<any, any>(state => state.user.info);

  return { loading, jobPost, userInfo, deleteJobPostHandler, publishJobPostHandler };
};

export default useJobPost;
